import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/base/api-service';
import { CreateMagazineData, MagazineCollectionResponse, MagazineData, UpdateMagazineData } from './magazine.model';
import EmptyResponse from '../shared/model/misc';

@Injectable({
  providedIn: 'root'
})
export class MagazineService extends ApiService {

  private restApiUrl = this.apiUrl('admin/magazines');

  constructor(private httpClient: HttpClient) {
    super();
  }

  public find(id: string): Observable<MagazineData> {
    return this.httpClient.get<MagazineData>(this.restApiUrl + '/' + id)
  }

  public findPaginated(
    page: number = 1,
    pageSize: number = 25,
    sortBy: string = 'name',
    sortDirection: string = 'desc',
    filter: string = '',
  ): Observable<MagazineCollectionResponse> {
    const queryParams = new HttpParams()
      .append('page', page.toString())
      .append('page_size', pageSize.toString())
      .append('sort_by', sortBy)
      .append('sort_direction', sortDirection)
      .append('filter', filter.trim());

    return this.httpClient
      .get<MagazineCollectionResponse>(this.restApiUrl, {params: queryParams})
  }

  public create(payload: CreateMagazineData): Observable<EmptyResponse> {
    return this.httpClient
      .post<EmptyResponse>(this.restApiUrl, payload)
  }

  public update(magazineId: string, payload: UpdateMagazineData): Observable<EmptyResponse> {
    return this.httpClient
      .put<EmptyResponse>(this.restApiUrl + '/' + magazineId, payload)
  }

  public delete(magazineId: string) {
    return this.httpClient.delete<EmptyResponse>(this.restApiUrl + '/' + magazineId)
  }
}
